<script lang="ts">
    import * as Table from '@/components/ui/table/index.js';
    import type { Snippet } from 'svelte';
    import type { Column, Row } from './index.js';
    import { inertia } from '@inertiajs/svelte';
    import TextLink from '../TextLink.svelte';
    import { formatDateLocale } from '@/lib/dateUtils';

    type Props = {
        column: Column;
        row: Row;
        currentlyHovering: null | { href: string; rowKey: unknown };
        aSnippet?: Snippet<[string]>;
        onRowClick?: (row: any, column: any) => any;
        getRowKey?: (row: Row) => unknown;
    };
    let {
        column,
        row,
        currentlyHovering = $bindable(null),
        aSnippet,
        onRowClick,
        getRowKey = (row) => row.id,
    }: Props = $props();
</script>

{#if 'type' in column.cellRender}
    {#if column.cellRender.type === 'custom'}
        {@render column.cellRender.snippet(row, column)}
    {:else}
        {@const href = column.cellRender?.link?.(row, column)}
        {@const label = column.cellRender.label(row, column)}
        <Table.Cell class="relative whitespace-normal break-words max-w-40" onclick={() => onRowClick?.(row, column)}>
            {#if column.cellRender.highlightLink}
                <TextLink href="#" class="text-primary">{label}</TextLink>
            {:else}
                {#if column.cellRender.type === 'date'}
                    <p>{formatDateLocale(label)}</p>
                {:else}
                    <p>{label}</p>
                {/if}
            {/if}
            {#if href}
                <!-- svelte-ignore a11y_no_static_element_interactions -->
                <div
                    class:hovering={currentlyHovering?.href === href &&
                        getRowKey(row) === currentlyHovering.rowKey}
                    class="a-wrapper"
                    aria-label={label}
                    onblur={() => {
                        currentlyHovering = null;
                    }}
                    onmouseover={() => {
                        currentlyHovering = {
                            href,
                            rowKey: getRowKey(row),
                        };
                    }}
                    onmouseout={() => {
                        currentlyHovering = null;
                    }}
                    onfocus={() => {
                        currentlyHovering = {
                            href,
                            rowKey: getRowKey(row),
                        };
                    }}
                >
                    {#if aSnippet}
                        {@render aSnippet(href)}
                    {:else}
                        <!-- svelte-ignore a11y_consider_explicit_label -->
                        <a {href} use:inertia={{ prefetch: true, cacheFor: 3000 }}></a>
                    {/if}
                </div>
            {/if}
        </Table.Cell>
    {/if}
{:else}
    <Table.Cell class="relative" onclick={() => onRowClick?.(row, column)}>
        <p>{column.cellRender(row, column)}</p>
    </Table.Cell>
{/if}

<style>
    .a-wrapper a {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
    }
    .hovering a {
        background: #00000015;
    }
</style>
